import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { MarkerDisplayComponent } from './marker-display.component';
import { MarkerModule } from '../marker/marker.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		MarkerModule
	],
	exports: [
		MarkerDisplayComponent
	],
	declarations: [
		MarkerDisplayComponent
	]
})
export class MarkerDisplayModule {}
